// extracted by mini-css-extract-plugin
export default {"container":"Container_container__i144x","content":"Container_content__llWvC"};